<app-auth-navbar></app-auth-navbar>
<div class="container marginTop">
    <div class="section-2">
        <div class="w-container">
            <h1 class="heading-2">Frequently Asked Questions</h1>
        </div>
    </div>
    <div class="section-3">
        <div class="container-6 w-container">
            <div class="faq-item">
                <div class="question mt-5">
                    <div><strong class="bold-text">Which countries can I send money from?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">Currently, you can send money only from Canada. We are adding new send countries so do please check with us periodically to see if your home country is now listed.</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">Which currencies are supported for sending money?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">Canadian Dollar (CAD)</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">Which currencies are supported for bill payments?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">We support over 20 currencies for bill payments including INR, MEX, &amp; NGN.</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">What are the fees for sending money?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">We display the rate, transfer fee and receivable amount before you make the transfer.</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">What is the minimum amount I can send?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">Our minimum send is $10 in $CAD</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">What is the maximum amount I can send?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">Our maximum send is $2,999. Should you wish to send a higher amount, please contact our support desk at support@n2xpress.com. </p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">Is my money safe?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">We provide complete transparency over your transactions and use bank-level encryption standards with thorough verification processes to make sure your money is safe and reaches the right people.</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">Why do I need to provide ID documentation?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">As a licensed Money Service Business, N2Xpress via Alpha Fortress Ltd is required to comply with Government legislation and regulations set out by the Financial Transactions and Reports Analysis Centre of Canada (FINTRAC). <br><br>As part of our obligations, we require at least one government issued identification document to enable you to process a transaction. We may ask you to provide additional documents to process larger amounts.</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">What documents can be submitted as proof of identity?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">We accept passport, driver’s license, or other government issued ID to verify your identity.</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">Paying with a credit card</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">We currently only offer debit card payments; we are working towards adding credit card payment options.</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">How do I cancel a money transfer?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">If the money transfer has not been released for payment, you may cancel your order by e-mailing customer support at support@n2xpress.com. A transfer that has been released for payment cannot be cancelled. </p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">How long does it take to get a refund?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">After we refund your order, please allow 2 to 5 business days for the refund to be completed. </p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">Can I cancel a mobile reload or bill payment?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">Since mobile phone reloads and utility bill payments are instant, you normally cannot cancel these transactions once you authorise the payment.</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">How do I check the status of a money transfer?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">You can login to your account to view the order status or e-mail customer support at support@n2xpress.com.</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">How will I know when my money transfer has been paid?</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">You will receive a notification when the money has been paid out. You can also login to your account to view the order status or e-mail customer support at support@n2xpress.com.<br><br>‍</p>
                    <div><strong class="bold-text">How long does it take for my transfer to get to my recipient?</strong></div>
                    <p class="paragraph">Our typical processing time is in minutes, but we may have delays due to banking holidays or other unforseen circumstances on our payout partners that could elongate processing times.<br>‍</p>
                    <div><strong class="bold-text">How do I create a transaction?</strong></div>
                    <p class="paragraph">To perform a transaction please follow these steps:<br><br>1. Add a recipient under &quot;Contact List&quot;<br>2. After creating your recipient click on &quot;Pay&quot;<br>3. Choose amount to send and decide whether to use Interac/EFT or Debit Card<br>4. Pay for the transaction by sending requested amount via Interac/EFT or using your Debit Card<br>5. Your recipient should be credited within minutes of a successful bank transfer or card payment</p>
                </div>
            </div>
            <div class="faq-item">
                <div class="question">
                    <div><strong class="bold-text">What’s Your Transaction Limit</strong></div>
                </div>
                <div class="answer">
                    <p class="paragraph">Subject to our KYC checks, you have an initial transaction limit of $999 and a monthly limit of $3,000. Should you wish to exceed that, please contact support@n2xpress.com and we can walk you through the process for getting a limit increase.</p>
                </div>
            </div>
        </div>
    </div>
</div>
<app-home-footer></app-home-footer>